import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AlertColor } from '@mui/material';

export interface UiState {
  snackBarText: string | null;
  snackBarSeverity: AlertColor;
  loadingType: 'simple' | 'progress' | null;
  loadingText: string | null;
  loadingStack: number;
  progress: number;
  activeRequestsCount: number;
}

const initialState: UiState = {
  snackBarText: null,
  snackBarSeverity: 'info',
  loadingType: null,
  loadingText: null,
  loadingStack: 0,
  progress: 0,
  activeRequestsCount: 0,
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    showSnackBar: (state, action: PayloadAction<{ text: string, severity: AlertColor }>) => {
      state.snackBarText = action.payload.text;
      state.snackBarSeverity = action.payload.severity;
    },
    hideSnackBar: (state, action: PayloadAction<void>) => {
      state.snackBarText = null
    },
    startLoading: (state, action: PayloadAction<'simple' | 'progress'>) => {
      state.activeRequestsCount += 1;
      state.loadingType = action.payload;
      if (action.payload === 'simple') {
        state.progress = 0;
      }
    },
    setProgress: (state, action: PayloadAction<number>) => {
      if (state.loadingType === 'progress') {
        state.progress = action.payload;
      }
    },
    setLoadingText: (state, action: PayloadAction<string | null>) => {
      state.loadingText = action.payload;
    },
    stopLoading: (state) => {
      state.activeRequestsCount -= 1;
      if (state.activeRequestsCount === 0) {
        state.loadingType = null;
        state.loadingText = null;
      }
      state.progress = 0;
    },
  },
});

export const {
  showSnackBar,
  hideSnackBar,
  startLoading,
  setProgress,
  setLoadingText,
  stopLoading,
} = uiSlice.actions;
